module.exports = __webpack_public_path__ + "static/img/future2.60b23d5d.png";